import styled from "styled-components";

export const SideInfoWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;
